import { useState } from "react";
import { InlineWidget } from "react-calendly";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const BookCalendly = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <div>
      <div className="mb-4">
        <div onClick={toggle}>Contact</div>
      </div>
      <Modal isOpen={modal} toggle={toggle} className="calendly-widget ">
        <ModalHeader className="justify-flex-center"></ModalHeader>
        <ModalBody>
          <InlineWidget url="https://calendly.com/carlosquintero92-cq" />
        </ModalBody>
        <ModalFooter>
          <Button
            className=" btn bg-brand-third"
            color="primary"
            onClick={toggle}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default BookCalendly;
